import { render } from "./InfinityLoader.vue?vue&type=template&id=1b81c69d&scoped=true"
import script from "./InfinityLoader.vue?vue&type=script&lang=js"
export * from "./InfinityLoader.vue?vue&type=script&lang=js"

import "./InfinityLoader.vue?vue&type=style&index=0&id=1b81c69d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b81c69d"]])

export default __exports__